import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { formatDateString } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["label-purchased-at"];

export const LabelPurchasedAtColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTableTextCell
      text={formatDateString(row.shipment?.boughtRate?.created_at ?? "")}
    />
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
